import {NgModule} from '@angular/core';
import {DateFormatPipe} from './date-format';
import {PercentFormatPipe} from './percent-format';
import {FileSizePipe} from './file-size';
import {NumberFormat} from './number-format';
import {DecimalPipe} from '@angular/common';
import {DateDifferencePipe} from './date-difference.pipe';
import {TruncatePipe} from './truncate.pipe';
import {NumberLongFormatPipe} from './number-long-format.pipe';
import {SafePipe} from './safe.pipe';
import {PermilleFormatPipe} from './permille-format';


@NgModule({
  declarations: [
    DateFormatPipe,
    PercentFormatPipe,
    PermilleFormatPipe,
    FileSizePipe,
    NumberFormat,
    DateDifferencePipe,
    TruncatePipe,
    NumberLongFormatPipe,
    SafePipe
  ],
  exports: [
    DateFormatPipe,
    PercentFormatPipe,
    PermilleFormatPipe,
    FileSizePipe,
    NumberFormat,
    DateDifferencePipe,
    TruncatePipe,
    NumberLongFormatPipe,
    SafePipe
  ],
  providers: [DecimalPipe]
})
export class PipesModule {
}
